// Basar-modulen (Phase 75): Bokmål-nøkkel → Nynorsk. Berre UI-tekst – basarnamn, premiar, skildringar og kontaktinfo frå arrangøren blir aldri omsette.
export const NN_BASAR = {
  // Felles / status
  "Basar": "Basar",
  "Trekningen er klar": "Trekninga er klar",
  "Salget er stengt": "Salet er stengt",
  "Åpner snart": "Opnar snart",
  "Loddsalg pågår": "Loddsal pågår",
  "Kladd": "Kladd",
  "Venter på Vipps": "Ventar på Vipps",
  "Betalt": "Betalt",
  "Kansellert": "Kansellert",
  "Refundert": "Refundert",
  "Kontant": "Kontant",
  "Vipps ved døren": "Vipps ved døra",
  "Annen betaling": "Anna betaling",
  "Vipps": "Vipps",

  // Oversikt (/basar)
  "Basar – kjøp lodd og støtt lokale lag": "Basar – kjøp lodd og støtt lokale lag",
  "Velg loddnumrene dine selv, betal med Vipps og få numrene på skjermen med en gang. Trekningen skjer digitalt, og vinnerne publiseres på basarsiden.": "Vel loddnummera dine sjølv, betal med Vipps og få nummera på skjermen med ein gong. Trekninga skjer digitalt, og vinnarane blir publiserte på basarsida.",
  "Vipps rett til arrangøren": "Vipps rett til arrangøren",
  "Premier med verdi": "Premiar med verdi",
  "Finn igjen loddene med mobilnummeret": "Finn att lodda med mobilnummeret",
  "Søk etter basar eller arrangør": "Søk etter basar eller arrangør",
  "{n} aktiv basar": "{n} aktiv basar",
  "{n} aktive basarer": "{n} aktive basarar",
  "Kunne ikke laste basarene": "Kunne ikkje laste basarane",
  "Ingen aktive basarer akkurat nå": "Ingen aktive basarar akkurat no",
  "Ingen basarer passet søket": "Ingen basarar passa søket",
  "Når arrangører åpner loddsalg, dukker basarene opp her.": "Når arrangørar opnar loddsal, dukkar basarane opp her.",
  "Prøv et annet søkeord.": "Prøv eit anna søkjeord.",
  "Nylig trukket": "Nyleg trekt",
  "Vinnerlistene ligger ute i 30 dager etter trekningen.": "Vinnarlistene ligg ute i 30 dagar etter trekninga.",
  "Velg nummer": "Vel nummer",
  "Trykk på ledige lodd i rutenettet – eller la oss trekke tilfeldige for deg.": "Trykk på ledige lodd i rutenettet – eller la oss trekkje tilfeldige for deg.",
  "Betal med Vipps": "Betal med Vipps",
  "Numrene reserveres mens du betaler og blir dine når betalingen er godkjent. Pengene går rett til arrangøren.": "Nummera blir reserverte medan du betaler og blir dine når betalinga er godkjend. Pengane går rett til arrangøren.",
  "Følg trekningen": "Følg trekninga",
  "Vinnerne publiseres på basarsiden. Har du oppgitt e-post, får du beskjed hvis du vinner.": "Vinnarane blir publiserte på basarsida. Har du oppgitt e-post, får du melding om du vinn.",

  // Kort
  "{amount} per lodd": "{amount} per lodd",
  "{amount}/lodd": "{amount}/lodd",
  "{n} premie": "{n} premie",
  "{n} premier": "{n} premiar",
  "Solgte lodd": "Selde lodd",
  "Solgt {sold} av {total}": "Selt {sold} av {total}",
  "Vinnerne er publisert": "Vinnarane er publiserte",
  "Salget slutter {date}": "Salet sluttar {date}",
  "Trekning kunngjøres av arrangøren": "Trekning blir kunngjord av arrangøren",
  "Se vinnerne": "Sjå vinnarane",
  "Se basar": "Sjå basar",

  // Teaser
  "Basaren vår": "Basaren vår",
  "Basaren er trukket": "Basaren er trekt",
  "Kjøp lodd": "Kjøp lodd",

  // Basarside
  "Alle basarer": "Alle basarar",
  "Fant ikke basaren": "Fann ikkje basaren",
  "Kunne ikke laste basaren": "Kunne ikkje laste basaren",
  "Basaren er ikke tilgjengelig lenger, eller lenken er feil.": "Basaren er ikkje tilgjengeleg lenger, eller lenkja er feil.",
  "Prøv igjen om litt.": "Prøv igjen om litt.",
  "Nummer {from}–{to}": "Nummer {from}–{to}",
  "Solgt {sold} av {total} lodd": "Selt {sold} av {total} lodd",
  "{n} ledige": "{n} ledige",
  "{n} reservert": "{n} reserverte",
  "Premier og vinnere": "Premiar og vinnarar",
  "Premier": "Premiar",
  "{n} vinner": "{n} vinnar",
  "{n} vinnere": "{n} vinnarar",
  "Premiene publiseres snart.": "Premiane blir publiserte snart.",
  "Loddene": "Lodda",
  "Velg loddnummer": "Vel loddnummer",
  "Om basaren": "Om basaren",
  "Arrangeres av": "Blir arrangert av",
  "Lotteritillatelse / referanse: {ref}": "Lotteriløyve / referanse: {ref}",
  "Right in formidler bare loddkjøpet. Arrangøren er ansvarlig for basaren, premiene og eventuell lotteritillatelse. Betalingen går direkte til arrangøren.": "Right in formidlar berre loddkjøpet. Arrangøren er ansvarleg for basaren, premiane og eventuelt lotteriløyve. Betalinga går direkte til arrangøren.",
  "Trekningen er gjennomført": "Trekninga er gjennomført",
  "Vinnerlisten står under premiene. Takk til alle som støttet!": "Vinnarlista står under premiane. Takk til alle som støtta!",
  "Publisert {date}.": "Publisert {date}.",
  "Loddsalget er stengt": "Loddsalet er stengt",
  "Trekningen kunngjøres av arrangøren. Vinnerne publiseres her.": "Trekninga blir kunngjord av arrangøren. Vinnarane blir publiserte her.",
  "Loddsalget åpner snart": "Loddsalet opnar snart",
  "Loddsalget er avsluttet": "Loddsalet er avslutta",
  "Salget starter {date}.": "Salet startar {date}.",
  "Salgsperioden er over. Trekningen kunngjøres av arrangøren.": "Salsperioden er over. Trekninga blir kunngjord av arrangøren.",
  "Alle lodd er solgt!": "Alle lodd er selde!",
  "Trekningen kunngjøres av arrangøren.": "Trekninga blir kunngjord av arrangøren.",
  "Lodd kjøpes hos arrangøren": "Lodd kan kjøpast hos arrangøren",
  "Arrangøren har ikke åpnet for Vipps-kjøp på nett ennå. Velg numrene du ønsker og kontakt arrangøren for å kjøpe dem.": "Arrangøren har ikkje opna for Vipps-kjøp på nett enno. Vel nummera du ønskjer og kontakt arrangøren for å kjøpe dei.",
  "Dine nummer: {numbers} ({amount})": "Nummera dine: {numbers} ({amount})",
  "Velg lodd": "Vel lodd",
  "Til betaling": "Til betaling",
  "Sum {amount}": "Sum {amount}",

  // Rutenett
  "Ledig": "Ledig",
  "Ikke solgt": "Ikkje selt",
  "Valgt": "Vald",
  "Reservert": "Reservert",
  "Solgt": "Selt",
  "Vinner": "Vinnar",
  "Oppdater": "Oppdater",
  "Forrige side": "Førre side",
  "Neste side": "Neste side",
  "Hopp til nr.": "Hopp til nr.",
  "Hopp til nummer": "Hopp til nummer",
  "Gå": "Gå",
  "Viser {start}–{end} av {total} lodd": "Viser {start}–{end} av {total} lodd",
  "Loddnummer": "Loddnummer",
  "ledig": "ledig",
  "valgt": "vald",
  "reservert": "reservert",
  "solgt": "selt",
  "vinner": "vinnar",
  "Lodd {n} – {state}": "Lodd {n} – {state}",

  // Premiekort
  "Verdi {amount}": "Verdi {amount}",
  "Premie {n}": "Premie {n}",
  "Lodd {n}": "Lodd {n}",

  // Kjøpspanel
  "minst {n}": "minst {n}",
  "maks {n}": "maks {n}",
  "{n} lodd valgt": "{n} lodd valt",
  "Dine nummer": "Nummera dine",
  "Tøm": "Tøm",
  "Trykk på ledige nummer i rutenettet, eller la oss velge tilfeldige for deg.": "Trykk på ledige nummer i rutenettet, eller la oss velje tilfeldige for deg.",
  "Fjern lodd {n}": "Fjern lodd {n}",
  "Antall lodd": "Tal lodd",
  "Velg tilfeldige for meg": "Vel tilfeldige for meg",
  "{n} tilfeldige lodd er valgt – du kan bytte dem i rutenettet": "{n} tilfeldige lodd er valde – du kan byte dei i rutenettet",
  "Velg {n} til for å nå minstekjøpet": "Vel {n} til for å nå minstekjøpet",
  "Navn": "Namn",
  "Mobilnummer": "Mobilnummer",
  "Brukes til å finne igjen loddene dine («Mine lodd») og hvis du vinner.": "Blir brukt til å finne att lodda dine («Mine lodd») og om du vinn.",
  "E-post (valgfritt)": "E-post (valfritt)",
  "Oppgir du e-post, får du loddnumrene på e-post og beskjed hvis du vinner.": "Oppgir du e-post, får du loddnummera på e-post og melding om du vinn.",
  "{n} lodd × {price}": "{n} lodd × {price}",
  "Sender deg til Vipps …": "Sender deg til Vipps …",
  "Velg minst {n} lodd": "Vel minst {n} lodd",
  "Maks {n} lodd per kjøp": "Maks {n} lodd per kjøp",
  "Betal med Vipps – {amount}": "Betal med Vipps – {amount}",
  "Numrene blir dine når Vipps-betalingen er godkjent. Kjøpet er bindende og betalingen går direkte til {org} – Right in formidler bare kjøpet.": "Nummera blir dine når Vipps-betalinga er godkjend. Kjøpet er bindande og betalinga går direkte til {org} – Right in formidlar berre kjøpet.",
  "Vilkår": "Vilkår",
  "Minimum {n} lodd per kjøp.": "Minimum {n} lodd per kjøp.",
  "Ingen egen lagre-knapp: valgte nummer blir holdt av i 15 minutter først når du trykker «Betal med Vipps», og frigis automatisk hvis betalingen ikke fullføres.": "Ingen eigen lagre-knapp: valde nummer blir haldne av i 15 minutt først når du trykkjer «Betal med Vipps», og blir frigjevne automatisk om betalinga ikkje blir fullført.",
  // Kjøpssteg (1 Velg lodd → 2 Dine opplysninger → 3 Betal)
  "Kjøpssteg": "Kjøpssteg",
  "Steg {n} av {total}": "Steg {n} av {total}",
  "Fullført": "Fullført",
  "Dine opplysninger": "Opplysningane dine",
  "Betal": "Betal",
  "Trykk på minst {n} ledige nummer i rutenettet. Valget lagres ikke for seg – numrene holdes av for deg først når du går til betaling.": "Trykk på minst {n} ledige nummer i rutenettet. Valet blir ikkje lagra for seg – nummera blir haldne av for deg først når du går til betaling.",
  "Trykk på ledige nummer i rutenettet. Valget lagres ikke for seg – numrene holdes av for deg først når du går til betaling.": "Trykk på ledige nummer i rutenettet. Valet blir ikkje lagra for seg – nummera blir haldne av for deg først når du går til betaling.",
  "Fyll inn navn og mobilnummer. E-post er valgfritt.": "Fyll inn namn og mobilnummer. E-post er valfritt.",
  "Trykk «Betal med Vipps». Numrene reserveres i 15 minutter mens du betaler, og blir dine når betalingen er godkjent.": "Trykk «Betal med Vipps». Nummera blir reserverte i 15 minutt medan du betaler, og blir dine når betalinga er godkjend.",
  "Trykk på ledige nummer for å velge eller fjerne dem. Valget lagres ikke for seg – numrene holdes av for deg først når du trykker «Betal med Vipps» i kjøpspanelet.": "Trykk på ledige nummer for å velje eller fjerne dei. Valet blir ikkje lagra for seg – nummera blir haldne av for deg først når du trykkjer «Betal med Vipps» i kjøpspanelet.",
  "Trykk på ledige nummer for å velge dem, og kontakt arrangøren for å kjøpe.": "Trykk på ledige nummer for å velje dei, og kontakt arrangøren for å kjøpe.",
  "Fyll inn navnet ditt": "Fyll inn namnet ditt",
  "Fyll inn et gyldig mobilnummer (8 siffer)": "Fyll inn eit gyldig mobilnummer (8 siffer)",
  "E-postadressen ser ikke riktig ut": "E-postadressa ser ikkje rett ut",
  "Noen av numrene ble tatt av andre akkurat nå ({numbers}). Velg andre nummer.": "Nokre av nummera vart tekne av andre akkurat no ({numbers}). Vel andre nummer.",

  // Mine lodd
  "Mine lodd": "Lodda mine",
  "Skriv inn mobilnummeret du brukte ved kjøpet, så finner vi loddene dine.": "Skriv inn mobilnummeret du brukte ved kjøpet, så finn vi lodda dine.",
  "Søk": "Søk",
  "{n} lodd registrert på nummeret": "{n} lodd registrerte på nummeret",
  "Gratulerer – du har vunnet!": "Gratulerer – du har vunne!",
  "Ingen av loddene dine ble trukket denne gangen. Takk for støtten!": "Ingen av lodda dine vart trekte denne gongen. Takk for støtta!",
  "Ordre {number}": "Ordre {number}",
  "Vi fant ingen betalte lodd på dette nummeret i denne basaren.": "Vi fann ingen betalte lodd på dette nummeret i denne basaren.",

  // Ordreside
  "Fant ikke bestillingen": "Fann ikkje bestillinga",
  "Vi venter fortsatt på Vipps": "Vi ventar framleis på Vipps",
  "Vi har ikke fått bekreftelse enda. Hvis du har betalt, prøv å oppdatere siden.": "Vi har ikkje fått stadfesting enno. Har du betalt, prøv å oppdatere sida.",
  "Sjekk på nytt": "Sjekk på nytt",
  "Fullfør betalingen i Vipps-appen – siden oppdateres automatisk. Numrene dine er reservert mens du betaler.": "Fullfør betalinga i Vipps-appen – sida blir oppdatert automatisk. Nummera dine er reserverte medan du betaler.",
  "Reservasjonen gjelder til kl. {time}": "Reservasjonen gjeld til kl. {time}",
  "Takk for støtten! Loddene er dine.": "Takk for støtta! Lodda er dine.",
  "Betalt {date}": "Betalt {date}",
  "Registrert av arrangøren": "Registrert av arrangøren",
  "Loddnummeret ditt": "Loddnummeret ditt",
  "Loddnumrene dine ({n})": "Loddnummera dine ({n})",
  "Arrangøren tar kontakt om utlevering. Du kan også kontakte arrangøren selv: {contact}": "Arrangøren tek kontakt om utlevering. Du kan òg kontakte arrangøren sjølv: {contact}",
  "Arrangøren tar kontakt om utlevering.": "Arrangøren tek kontakt om utlevering.",
  "Ta gjerne et skjermbilde eller lagre denne lenken – den viser alltid loddene dine.": "Ta gjerne eit skjermbilete eller lagre denne lenkja – ho viser alltid lodda dine.",
  "Du finner også loddene igjen under «Mine lodd» på basarsiden med mobilnummeret ditt.": "Du finn òg lodda att under «Lodda mine» på basarsida med mobilnummeret ditt.",
  "Betalingen ble avbrutt og numrene er frigitt. Du kan velge nummer på nytt.": "Betalinga vart avbroten og nummera er frigjevne. Du kan velje nummer på nytt.",
  "Velg nummer på nytt": "Vel nummer på nytt",
  "Bestillingen er refundert ({amount}) og numrene er frigitt.": "Bestillinga er refundert ({amount}) og nummera er frigjevne.",
  "Loddkjøpet ditt": "Loddkjøpet ditt",
  "Totalt": "Totalt",
  "Kvittering med loddnumrene er sendt på e-post.": "Kvittering med loddnummera er send på e-post.",
  "Basaren arrangeres av {org}. Betalingen går direkte til arrangøren – Right in formidler bare kjøpet.": "Basaren blir arrangert av {org}. Betalinga går direkte til arrangøren – Right in formidlar berre kjøpet.",
  "Tilbake til basaren": "Tilbake til basaren",

  // ---------- Dashbord (arrangør) ----------
  "Oppsett": "Oppsett",
  "Trekning": "Trekning",
  "Brødsmuler": "Brødsmular",
  "Moduler: Butikk og Basar": "Modular: Butikk og Basar",
  "Tilleggsmoduler": "Tilleggsmodular",
  "Selg varer med Vipps eller faktura": "Sel varer med Vipps eller faktura",
  "Loddsalg med Vipps og digital trekning": "Loddsal med Vipps og digital trekning",
  "JPG, PNG eller WEBP, maks 5 MB.": "JPG, PNG eller WEBP, maks 5 MB.",

  // Liste
  "{n} kjøper": "{n} kjøpar",
  "{n} kjøpere": "{n} kjøparar",
  "{n} venter på Vipps": "{n} ventar på Vipps",
  "Åpne": "Opne",
  "Ny basar": "Ny basar",
  "Vipps er ikke satt opp": "Vipps er ikkje sett opp",
  "Publikum kan ikke kjøpe lodd på nett før Vipps er klart – pengene går rett inn på deres egen Vipps-salgsenhet. Manuelle salg (kontant / Vipps ved døren) kan registreres uansett.": "Publikum kan ikkje kjøpe lodd på nett før Vipps er klart – pengane går rett inn på dykkar eiga Vipps-salseining. Manuelle sal (kontant / Vipps ved døra) kan registrerast uansett.",
  "Loddsalg med egne nummer, Vipps og digital trekning": "Loddsal med eigne nummer, Vipps og digital trekning",
  "Sett opp en nummerserie (f.eks. 1–1000), pris per lodd og premier. Kjøperne velger numrene sine selv og betaler med Vipps – eller dere registrerer salg ved døren. Trekningen gjøres her i Right in, og vinnerlisten publiseres på basarsiden.": "Set opp ein nummerserie (t.d. 1–1000), pris per lodd og premiar. Kjøparane vel nummera sine sjølve og betaler med Vipps – eller de registrerer sal ved døra. Trekninga blir gjord her i Right in, og vinnarlista blir publisert på basarsida.",
  "Opprett din første basar": "Opprett den første basaren din",
  "Aktive basarer": "Aktive basarar",
  "Trukne basarer": "Trekte basarar",

  // Oppsett
  "Sjekk feltene – navn, nummerserie og pris må fylles ut": "Sjekk felta – namn, nummerserie og pris må fyllast ut",
  "Basaren er opprettet – legg til premiene": "Basaren er oppretta – legg til premiane",
  "Basaren er lagret": "Basaren er lagra",
  "Basaren er slettet": "Basaren er sletta",
  "Navn, nummerserie, pris og regler for kjøp. Premiene legger du til i neste steg.": "Namn, nummerserie, pris og reglar for kjøp. Premiane legg du til i neste steg.",
  "Basaren er trukket og kan ikke endres.": "Basaren er trekt og kan ikkje endrast.",
  "Navn på basaren": "Namn på basaren",
  "F.eks. Vårbasaren 2026": "T.d. Vårbasaren 2026",
  "Hva går overskuddet til? Når og hvor trekkes det?": "Kva går overskotet til? Når og kvar blir det trekt?",
  "Bilde (valgfritt)": "Bilete (valfritt)",
  "Brukes som toppbilde på basarsiden og i oversikten. Liggende format fungerer best.": "Blir brukt som toppbilete på basarsida og i oversikta. Liggjande format fungerer best.",
  "Nummerserie og pris": "Nummerserie og pris",
  "Det er solgt lodd: pris og startnummer er låst, serien kan bare utvides.": "Det er selt lodd: pris og startnummer er låste, serien kan berre utvidast.",
  "Fra nummer": "Frå nummer",
  "Til nummer": "Til nummer",
  "Pris per lodd (kr)": "Pris per lodd (kr)",
  "Maks {n} lodd i én serie": "Maks {n} lodd i éin serie",
  "Serien må gå fra et lavere til et høyere nummer": "Serien må gå frå eit lågare til eit høgare nummer",
  "{total} lodd · fullt salg gir {amount}": "{total} lodd · fullt sal gir {amount}",
  "Regler for kjøp": "Reglar for kjøp",
  "Minste antall lodd per kjøp": "Minste tal lodd per kjøp",
  "Maks antall lodd per kjøp": "Maks tal lodd per kjøp",
  "Salgsperiode (valgfritt)": "Salsperiode (valfritt)",
  "Tomme felt = salget er åpent så lenge basaren har status Åpen.": "Tomme felt = salet er ope så lenge basaren har status Open.",
  "Salgsstart": "Salsstart",
  "Salgsslutt": "Salsslutt",
  "Informasjon til publikum": "Informasjon til publikum",
  "Når og hvor trekkes det?": "Når og kvar blir det trekt?",
  "F.eks. Trekning 17. mai etter toget, vinnerne publiseres her": "T.d. Trekning 17. mai etter toget, vinnarane blir publiserte her",
  "Kontakt for kjøpere og vinnere": "Kontakt for kjøparar og vinnarar",
  "F.eks. basar@laget.no / 900 00 000": "T.d. basar@laget.no / 900 00 000",
  "Lotteritillatelse / referanse (valgfritt)": "Lotteriløyve / referanse (valfritt)",
  "Arrangøren er selv ansvarlig for at basaren er lovlig (Lotteritilsynet). Referansen vises på basarsiden.": "Arrangøren er sjølv ansvarleg for at basaren er lovleg (Lotteritilsynet). Referansen blir vist på basarsida.",
  "Vis vinnernes navn i den offentlige vinnerlisten": "Vis namna til vinnarane i den offentlege vinnarlista",
  "Loddnummer og fullt navn vises på basarsiden etter trekningen.": "Loddnummer og fullt namn blir vist på basarsida etter trekninga.",
  "Bare loddnummer vises offentlig – du ser navn og mobil i dashbordet.": "Berre loddnummer blir vist offentleg – du ser namn og mobil i dashbordet.",
  "Opprett basar": "Opprett basar",
  "Basaren har solgte lodd og kan ikke slettes – steng den i stedet": "Basaren har selde lodd og kan ikkje slettast – steng han i staden",
  "Slette basaren?": "Slette basaren?",
  "Basaren og premiene fjernes. Dette kan ikke angres.": "Basaren og premiane blir fjerna. Dette kan ikkje angrast.",
  "Slik kommer du i gang": "Slik kjem du i gang",
  "navn, nummerserie, pris og regler.": "namn, nummerserie, pris og reglar.",
  "bilde, verdi og antall eksemplarer.": "bilete, verdi og tal eksemplar.",
  "Åpne salget": "Opne salet",
  "del lenken, registrer salg ved døren.": "del lenkja, registrer sal ved døra.",
  "trekk vinnere og publiser listen.": "trekk vinnarar og publiser lista.",
  "Betalingene går direkte til deres egen Vipps-salgsenhet. Right in tar ingen avgift på loddsalg og formidler bare kjøpet.": "Betalingane går direkte til dykkar eiga Vipps-salseining. Right in tek inga avgift på loddsal og formidlar berre kjøpet.",

  // Oversikt per basar
  "Loddsalget er åpnet": "Loddsalet er opna",
  "Basaren er satt tilbake til kladd": "Basaren er sett tilbake til kladd",
  "Kunne ikke kopiere – merk lenken og kopier manuelt": "Kunne ikkje kopiere – merk lenkja og kopier manuelt",
  "Legg til minst én premie før basaren åpnes": "Legg til minst éin premie før basaren blir opna",
  "Premiene vises på basarsiden og trekkes i Right in.": "Premiane blir viste på basarsida og trekte i Right in.",
  "Legg til premier": "Legg til premiar",
  "Publikum kan ikke kjøpe lodd på nett før Vipps er klart. Manuelle salg kan registreres uansett.": "Publikum kan ikkje kjøpe lodd på nett før Vipps er klart. Manuelle sal kan registrerast uansett.",
  "{n} reservert i Vipps nå": "{n} reserverte i Vipps no",
  "Vipps {vipps} · manuelt {manual}": "Vipps {vipps} · manuelt {manual}",
  "Kjøpere": "Kjøparar",
  "{n} salg": "{n} sal",
  "Publisert {date}": "Publisert {date}",
  "Ingen salgsperiode satt": "Inga salsperiode sett",
  "Status og salg": "Status og sal",
  "Basaren er en kladd og vises ikke offentlig ennå.": "Basaren er ein kladd og blir ikkje vist offentleg enno.",
  "Loddsalget er åpent. Publikum kan kjøpe lodd på basarsiden, og dere kan registrere salg ved døren.": "Loddsalet er ope. Publikum kan kjøpe lodd på basarsida, og de kan registrere sal ved døra.",
  "Salget er stengt. Du kan fortsatt registrere manuelle salg, og trekke vinnerne når dere er klare.": "Salet er stengt. Du kan framleis registrere manuelle sal, og trekkje vinnarane når de er klare.",
  "Trekningen er publisert. Vinnerlisten ligger på basarsiden.": "Trekninga er publisert. Vinnarlista ligg på basarsida.",
  "Åpne loddsalget": "Opne loddsalet",
  "Steng salget": "Steng salet",
  "Tilbake til kladd": "Tilbake til kladd",
  "Gå til trekning": "Gå til trekning",
  "Åpne salget igjen": "Opne salet igjen",
  "Se vinnerlisten": "Sjå vinnarlista",
  "{n} betaling(er) venter på Vipps. Ubetalte reservasjoner frigis automatisk etter 15 minutter.": "{n} betaling(ar) ventar på Vipps. Ubetalte reservasjonar blir frigjevne automatisk etter 15 minutt.",
  "Alle salg": "Alle sal",
  "Lenke til basarsiden": "Lenkje til basarsida",
  "Siden blir synlig når loddsalget åpnes. Basaren vises også på arrangørsiden og i den felles oversikten.": "Sida blir synleg når loddsalet blir opna. Basaren blir òg vist på arrangørsida og i den felles oversikta.",
  "Del lenken på Facebook, i gruppechatten eller på plakaten. Basaren vises også på arrangørsiden og i den felles oversikten /basar.": "Del lenkja på Facebook, i gruppechatten eller på plakaten. Basaren blir òg vist på arrangørsida og i den felles oversikta /basar.",
  "{n} eksemplarer": "{n} eksemplar",
  "verdi {amount}": "verdi {amount}",
  "Se premier": "Sjå premiar",
  "+ {n} til": "+ {n} til",
  "Trekning påbegynt: {drawn} av {total} trukket (ikke publisert)": "Trekning påbyrja: {drawn} av {total} trekte (ikkje publisert)",
  "Åpne loddsalget?": "Opne loddsalet?",
  "Stenge loddsalget?": "Stengje loddsalet?",
  "Sette basaren tilbake til kladd?": "Setje basaren tilbake til kladd?",
  "Basarsiden blir offentlig, og publikum kan kjøpe lodd med Vipps.": "Basarsida blir offentleg, og publikum kan kjøpe lodd med Vipps.",
  "Basarsiden blir offentlig. Vipps er ikke satt opp, så publikum kan ikke kjøpe på nett ennå – men dere kan registrere salg manuelt.": "Basarsida blir offentleg. Vipps er ikkje sett opp, så publikum kan ikkje kjøpe på nett enno – men de kan registrere sal manuelt.",
  "Publikum kan ikke lenger kjøpe lodd på nett. Manuelle salg kan fortsatt registreres, og du kan åpne igjen senere.": "Publikum kan ikkje lenger kjøpe lodd på nett. Manuelle sal kan framleis registrerast, og du kan opne igjen seinare.",
  "Basaren skjules fra offentligheten igjen.": "Basaren blir skjult for offentlegheita igjen.",
  "Steng": "Steng",
  "Ja": "Ja",

  // Premiar
  "Alle premier må ha navn og minst ett eksemplar": "Alle premiar må ha namn og minst eitt eksemplar",
  "Premiene er lagret": "Premiane er lagra",
  "Premie uten navn": "Premie utan namn",
  "Lagre premier": "Lagre premiar",
  "Trekningen er publisert": "Trekninga er publisert",
  "Premiene kan ikke endres etter at vinnerlisten er publisert.": "Premiane kan ikkje endrast etter at vinnarlista er publisert.",
  "Ingen premier ennå": "Ingen premiar enno",
  "Legg til minst én premie før basaren åpnes. Hver premie kan ha flere eksemplarer – da trekkes det like mange vinnere.": "Legg til minst éin premie før basaren blir opna. Kvar premie kan ha fleire eksemplar – då blir det trekt like mange vinnarar.",
  "Flytt opp": "Flytt opp",
  "Flytt ned": "Flytt ned",
  "Fjern premie": "Fjern premie",
  "Navn på premien": "Namn på premien",
  "F.eks. Gavekort Kiwi 1000 kr": "T.d. Gåvekort Kiwi 1000 kr",
  "Verdi (kr)": "Verdi (kr)",
  "Beskrivelse (valgfritt)": "Skildring (valfritt)",
  "JPG, PNG eller WEBP, maks 5 MB. Et godt bilde selger flere lodd.": "JPG, PNG eller WEBP, maks 5 MB. Eit godt bilete sel fleire lodd.",
  "Legg til premie": "Legg til premie",
  "Ulagrede endringer": "Ulagra endringar",
  "Slik vises premiene": "Slik blir premiane viste",
  "Premiene dukker opp her etter hvert som du legger dem til.": "Premiane dukkar opp her etter kvart som du legg dei til.",

  // Sal
  "Salget er angret og numrene er frigitt": "Salet er angra og nummera er frigjevne",
  "Bestillingen er kansellert": "Bestillinga er kansellert",
  "Manuelt": "Manuelt",
  "Nett": "Nett",
  "Åpne basaren før du registrerer salg": "Opne basaren før du registrerer sal",
  "Basaren er en kladd. Åpne loddsalget fra oversikten før du registrerer salg.": "Basaren er ein kladd. Opne loddsalet frå oversikta før du registrerer sal.",
  "Søk på navn, mobil, loddnummer eller ordre": "Søk på namn, mobil, loddnummer eller ordre",
  "Ingen salg passet søket": "Ingen sal passa søket",
  "Ingen salg ennå": "Ingen sal enno",
  "Prøv et annet søkeord eller filter.": "Prøv eit anna søkjeord eller filter.",
  "Nettsalg dukker opp her automatisk. Salg ved døren registrerer du med knappen «Registrer salg».": "Nettsal dukkar opp her automatisk. Sal ved døra registrerer du med knappen «Registrer sal».",
  "{n} lodd": "{n} lodd",
  "Kvittering sendt": "Kvittering send",
  "Se kjøperens ordreside": "Sjå ordresida til kjøparen",
  "Refunder via Vipps og frigi numrene": "Refunder via Vipps og frigje nummera",
  "Angre salget og frigi numrene": "Angre salet og frigje nummera",
  "Kanseller reservasjonen": "Kanseller reservasjonen",
  "Lodd": "Lodd",
  "Ordreside": "Ordreside",
  "Angre salget?": "Angre salet?",
  "Kansellere reservasjonen?": "Kansellere reservasjonen?",
  "Beløpet ({amount}) refunderes via Vipps, og loddnumrene {numbers} blir ledige igjen.": "Beløpet ({amount}) blir refundert via Vipps, og loddnummera {numbers} blir ledige igjen.",
  "Salget merkes som refundert (pengene må dere gjøre opp selv), og loddnumrene {numbers} blir ledige igjen.": "Salet blir merkt som refundert (pengane må de gjere opp sjølve), og loddnummera {numbers} blir ledige igjen.",
  "Vipps-betalingen avbrytes og numrene frigis.": "Vipps-betalinga blir avbroten og nummera frigjevne.",
  "Begrunnelse (valgfritt)": "Grunngjeving (valfritt)",
  "Ja, angre salget": "Ja, angre salet",
  "Betalte": "Betalte",

  // Manuelt sal
  "Fyll inn navnet på kjøperen": "Fyll inn namnet på kjøparen",
  "Velg minst ett nummer i rutenettet": "Vel minst eitt nummer i rutenettet",
  "Oppgi antall lodd": "Oppgi tal lodd",
  "Registrert: lodd {numbers} til {name}": "Registrert: lodd {numbers} til {name}",
  "Noen av numrene er allerede solgt eller reservert ({numbers}). Velg andre.": "Nokre av nummera er alt selde eller reserverte ({numbers}). Vel andre.",
  "Registrer salg ved døren": "Registrer sal ved døra",
  "For kontantsalg og Vipps direkte til dere. Numrene trekkes fra samme serie som nettsalget og blir solgt med en gang.": "For kontantsal og Vipps direkte til dykk. Nummera blir tekne frå same serie som nettsalet og blir selde med ein gong.",
  "Send kvittering med loddnumrene på e-post": "Send kvittering med loddnummera på e-post",
  "E-post er ikke aktivert i denne installasjonen": "E-post er ikkje aktivert i denne installasjonen",
  "Velg nummer selv": "Vel nummer sjølv",
  "Auto-plukk": "Auto-plukk",
  "lodd": "lodd",
  "Valgt: {numbers}": "Valt: {numbers}",
  "De laveste ledige numrene tildeles automatisk.": "Dei lågaste ledige nummera blir tildelte automatisk.",
  "Merknad (internt)": "Merknad (internt)",
  "F.eks. solgt av Kari på standen": "T.d. selt av Kari på standen",
  "Registrer salg": "Registrer sal",

  // Trekning
  "Trekningen er nullstilt": "Trekninga er nullstilt",
  "Vinnerlisten er publisert – {n} vinner(e) får e-post": "Vinnarlista er publisert – {n} vinnar(ar) får e-post",
  "Vinnerlisten er publisert": "Vinnarlista er publisert",
  "{drawn} av {total} trukket": "{drawn} av {total} trekte",
  "Vinnerlisten ligger på basarsiden. Salget er stengt og trekningen kan ikke endres.": "Vinnarlista ligg på basarsida. Salet er stengt og trekninga kan ikkje endrast.",
  "Hver trekning velger et tilfeldig solgt lodd (kryptografisk tilfeldig) som ikke allerede har vunnet. Ingenting blir offentlig før du publiserer.": "Kvar trekning vel eit tilfeldig selt lodd (kryptografisk tilfeldig) som ikkje alt har vunne. Ingenting blir offentleg før du publiserer.",
  "{sold} solgte lodd · {copies} premier/eksemplarer å trekke": "{sold} selde lodd · {copies} premiar/eksemplar å trekkje",
  "Nullstill trekningen": "Nullstill trekninga",
  "Publiser vinnerlisten": "Publiser vinnarlista",
  "Basaren er en kladd – åpne loddsalget og selg lodd før trekningen.": "Basaren er ein kladd – opne loddsalet og sel lodd før trekninga.",
  "Ingen solgte lodd ennå": "Ingen selde lodd enno",
  "Trekningen kan starte når minst ett lodd er solgt.": "Trekninga kan starte når minst eitt lodd er selt.",
  "{n} betaling(er) venter på Vipps": "{n} betaling(ar) ventar på Vipps",
  "Du kan trekke nå, men vinnerlisten kan først publiseres når alle betalinger er fullført eller kansellert (ubetalte frigis automatisk etter 15 minutter).": "Du kan trekkje no, men vinnarlista kan først publiserast når alle betalingar er fullførte eller kansellerte (ubetalte blir frigjevne automatisk etter 15 minutt).",
  "Loddsalget er fortsatt åpent. Når du publiserer vinnerlisten, stenges salget automatisk.": "Loddsalet er framleis ope. Når du publiserer vinnarlista, blir salet stengt automatisk.",
  "Steng salget først": "Steng salet først",
  "Ferdig trukket": "Ferdig trekt",
  "Eksemplar {slot} av {count}": "Eksemplar {slot} av {count}",
  "Trekk vinner": "Trekk vinnar",
  "Vinnerlodd": "Vinnarlodd",
  "Ukjent kjøper": "Ukjend kjøpar",
  "e-post sendt": "e-post send",
  "sender …": "sender …",
  "Trekk på nytt": "Trekk på nytt",
  "Publisere vinnerlisten?": "Publisere vinnarlista?",
  "Nullstille trekningen?": "Nullstille trekninga?",
  "Alle trekninger slettes og du kan trekke på nytt. Ingenting er publisert ennå.": "Alle trekningar blir sletta og du kan trekkje på nytt. Ingenting er publisert enno.",

  // ---- Phase 76: loddkvittering med QR + utlevering (kontrollside) ----
  "QR-kode for kvitteringen – vises ved utlevering av premier": "QR-kode for kvitteringa – vis han ved utlevering av premiar",
  "Kvittering og utleveringskode": "Kvittering og utleveringskode",
  "Vis denne koden når du henter en premie – arrangøren skanner den i Right in og ser loddene dine og eventuelle gevinster.": "Vis denne koden når du hentar ein premie – arrangøren skannar han i Right in og ser lodda dine og eventuelle gevinstar.",
  "Last ned kvittering (PDF)": "Last ned kvittering (PDF)",
  "Utlevering": "Utlevering",
  "Utlevering (skann kvittering)": "Utlevering (skann kvittering)",
  "Utlevering av premier": "Utlevering av premiar",
  "Skann QR-koden på kjøperens kvittering (ordresiden eller PDF-en), eller skriv inn ordrenummer eller loddnummer. Etter publisert trekning kan du merke premiene som utlevert.": "Skann QR-koden på kvitteringa til kjøparen (ordresida eller PDF-en), eller skriv inn ordrenummer eller loddnummer. Etter publisert trekning kan du merke premiane som utleverte.",
  "Trykk «Start kamera» for å skanne kvitteringen.": "Trykk «Start kamera» for å skanne kvitteringa.",
  "Kunne ikke starte kameraet. Gi tilgang til kamera, eller skriv inn koden under.": "Kunne ikkje starte kameraet. Gje tilgang til kamera, eller skriv inn koden under.",
  "Eller skriv inn kode": "Eller skriv inn kode",
  "Ordrenummer (L-…) eller loddnummer": "Ordrenummer (L-…) eller loddnummer",
  "Slå opp": "Slå opp",
  "Loddnummer finner ordren som kjøpte loddet. Du kan også lime inn lenken fra QR-koden.": "Loddnummer finn ordren som kjøpte loddet. Du kan òg lime inn lenka frå QR-koden.",
  "Kvittering funnet": "Kvittering funnen",
  "Ingen kvittering valgt": "Inga kvittering vald",
  "Skann en kvittering for å se gevinster og merke premier som utlevert.": "Skann ei kvittering for å sjå gevinstar og merke premiar som utleverte.",
  "Trekningen er ikke publisert ennå. Du kan likevel kontrollere kvitteringer – gevinster vises her etter publisering.": "Trekninga er ikkje publisert enno. Du kan likevel kontrollere kvitteringar – gevinstar blir viste her etter publisering.",
  "Gyldig – loddene er betalt": "Gyldig – lodda er betalte",
  "Ikke betalt ennå – venter på Vipps": "Ikkje betalt enno – ventar på Vipps",
  "Ugyldig – ordren er refundert": "Ugyldig – ordren er refundert",
  "Ugyldig – ordren er kansellert": "Ugyldig – ordren er kansellert",
  "Loddnumre ({n})": "Loddnummer ({n})",
  "Gevinster": "Gevinstar",
  "{done} av {total} utlevert": "{done} av {total} utleverte",
  "Trekningen er ikke publisert ennå – gevinster og utlevering vises her etter publisering.": "Trekninga er ikkje publisert enno – gevinstar og utlevering blir viste her etter publisering.",
  "Ingen gevinst på disse loddene.": "Ingen gevinst på desse lodda.",
  "Utlevert {date}": "Utlevert {date}",
  "Merk som utlevert": "Merk som utlevert",
  "Premien er merket som utlevert": "Premien er merkt som utlevert",
  "Utlevering angret": "Utlevering angra",
  "Vis i salgslisten": "Vis i salslista",
  "Utlevert": "Utlevert",
  "Utlever": "Utlever",
  // ---- Phase 76: delingskort ----
  "Delingskort": "Delingskort",
  "Kvadratisk bilde (1080×1080) med de største premiene, pris per lodd og QR til basarsiden – klart for Facebook og Instagram.": "Kvadratisk bilete (1080×1080) med dei største premiane, pris per lodd og QR til basarsida – klart for Facebook og Instagram.",
  "Lag på nytt": "Lag på nytt",
  "Delingskortet er laget på nytt": "Delingskortet er laga på nytt",
  "Kunne ikke lage delingskortet.": "Kunne ikkje lage delingskortet.",
  "Delingskort for {name}": "Delingskort for {name}",
  "Last ned bilde": "Last ned bilete",
  "Åpne loddsalget først – kladder kan ikke deles": "Opne loddsalet først – kladdar kan ikkje delast",
  "Delingslenken er kopiert": "Delingslenka er kopiert",
  "Delingslenken viser dette kortet som forhåndsvisning når den deles på Facebook, Messenger eller i gruppechatten.": "Delingslenka viser dette kortet som førehandsvising når ho blir delt på Facebook, Messenger eller i gruppechatten.",
  "Når loddsalget er åpnet, kan du dele lenken – kortet blir da forhåndsvisningen på Facebook.": "Når loddsalet er opna, kan du dele lenka – kortet blir då førehandsvisinga på Facebook.",

  // ---- Phase 77: utleveringsliste (PDF) + vinnar-SMS (simulert) ----
  "Utleveringsliste (PDF)": "Utleveringsliste (PDF)",
  "Vinner-SMS til {n} kjøper(e) er simulert (ingen ekte SMS sendes ennå)": "Vinnar-SMS til {n} kjøpar(ar) er simulert (ingen ekte SMS blir sende enno)",
  "Vinner-SMS sendes til {n} kjøper(e)": "Vinnar-SMS blir send til {n} kjøpar(ar)",
  "Alle vinnere har allerede fått SMS": "Alle vinnarane har alt fått SMS",
  "SMS til {n} kjøper(e) simulert – ingen ekte SMS sendt": "SMS til {n} kjøpar(ar) simulert – ingen ekte SMS send",
  "SMS sendt til {n} kjøper(e)": "SMS send til {n} kjøpar(ar)",
  "{n} SMS feilet": "{n} SMS feila",
  "Vinner-SMS": "Vinnar-SMS",
  "Simulert": "Simulert",
  "{sent} av {total} vinnere har fått SMS med premie, loddnummer og lenke til kvitteringen.": "{sent} av {total} vinnarar har fått SMS med premie, loddnummer og lenke til kvitteringa.",
  "{n} feilet.": "{n} feila.",
  "SMS-utsending er foreløpig simulert: meldingene logges i Right in, men ingen ekte SMS sendes før en SMS-leverandør er koblet til.": "SMS-utsending er førebels simulert: meldingane blir logga i Right in, men ingen ekte SMS blir sende før ein SMS-leverandør er kopla til.",
  "Send SMS til {n} som mangler": "Send SMS til {n} som manglar",
  "Alle har fått SMS": "Alle har fått SMS",
  "Send til alle på nytt": "Send til alle på nytt",
  "SMS feilet": "SMS feila",
  "SMS simulert {date}": "SMS simulert {date}",
  "SMS sendt {date}": "SMS send {date}",
  "SMS ikke sendt": "SMS ikkje send",
  "Vinnerlisten blir synlig på basarsiden, loddsalget stenges, og vinnerne får beskjed på SMS (og e-post der den er oppgitt). Dette kan ikke angres.": "Vinnarlista blir synleg på basarsida, loddsalet blir stengt, og vinnarane får melding på SMS (og e-post der han er oppgitt). Dette kan ikkje angrast.",

  // Gi premie / gåveregister / plakat (Phase 78)
  "Gi premie": "Gi premie",
  "Gi en premie til {basar}": "Gi ein premie til {basar}",
  "Privatpersoner og bedrifter kan støtte basaren med en pengegave eller en gjenstand. Gaven blir med i premielisten med en gang – navnet ditt vises ikke offentlig.": "Privatpersonar og bedrifter kan støtte basaren med ei pengegåve eller ein gjenstand. Gåva blir med i premielista med ein gong – namnet ditt blir ikkje vist offentleg.",
  "Privatpersoner og bedrifter kan støtte basaren med en pengegave{vipps} eller en gjenstand. Gaven blir med i premielisten med en gang – giverens navn vises ikke offentlig.": "Privatpersonar og bedrifter kan støtte basaren med ei pengegåve{vipps} eller ein gjenstand. Gåva blir med i premielista med ein gong – namnet på givaren blir ikkje vist offentleg.",
  "Vil du gi en premie?": "Vil du gi ein premie?",
  "Pengegave": "Pengegåve",
  "Pengegaver": "Pengegåver",
  "Tinggave": "Tinggåve",
  "Tinggaver": "Tinggåver",
  "Betales med Vipps og blir en pengepremie": "Blir betalt med Vipps og blir ein pengepremie",
  "Arrangøren har ikke Vipps ennå": "Arrangøren har ikkje Vipps enno",
  "En gjenstand, et gavekort e.l. – arrangøren henter den": "Ein gjenstand, eit gåvekort e.l. – arrangøren hentar han",
  "Minste beløp er {amount}. Beløpet blir en egen pengepremie i basaren.": "Minste beløp er {amount}. Beløpet blir ein eigen pengepremie i basaren.",
  "Minste pengegave er {amount}": "Minste pengegåve er {amount}",
  "Hva er gaven?": "Kva er gåva?",
  "F.eks. Rosebukett fra Spar Sæbøvik": "T.d. Rosebukett frå Spar Sæbøvik",
  "F.eks. Rosebuketter fra Spar Sæbøvik": "T.d. Rosebukettar frå Spar Sæbøvik",
  "Antall like": "Tal like",
  "Verdi per stykk må oppgis. Gir du flere like, trekkes det like mange vinnere.": "Verdi per stykk må oppgjevast. Gir du fleire like, blir det trekt like mange vinnarar.",
  "Størrelse, farge, innhold …": "Storleik, farge, innhald …",
  "Om deg": "Om deg",
  "Privatperson": "Privatperson",
  "Bedrift": "Bedrift",
  "Bedriftens navn": "Namnet på bedrifta",
  "Melding til arrangøren (valgfritt)": "Melding til arrangøren (valfritt)",
  "F.eks. når gaven kan hentes": "T.d. når gåva kan hentast",
  "Kontaktopplysningene brukes bare av arrangøren til å avtale henting og takke. Oppgir du e-post, får du en bekreftelse.": "Kontaktopplysningane blir berre brukte av arrangøren til å avtale henting og takke. Oppgir du e-post, får du ei stadfesting.",
  "Registrerer …": "Registrerer …",
  "Gi gaven": "Gi gåva",
  "Skriv hva gaven er": "Skriv kva gåva er",
  "Oppgi verdien på gaven i kroner": "Oppgi verdien på gåva i kroner",
  "Oppgi beløpet i kroner": "Oppgi beløpet i kroner",
  "Tusen takk! Gaven er registrert som premie.": "Tusen takk! Gåva er registrert som premie.",
  "Pengegaven går direkte til {org} sin Vipps-konto og blir lagt inn som premie når betalingen er godkjent. Right in formidler bare gaven.": "Pengegåva går direkte til {org} sin Vipps-konto og blir lagd inn som premie når betalinga er godkjend. Right in formidlar berre gåva.",
  "Trekning {date}": "Trekning {date}",
  "Elektronisk trekning – vinnerne publiseres her på basarsiden.": "Elektronisk trekning – vinnarane blir publiserte her på basarsida.",
  // Gåvesida (/basar/gave/:id)
  "Fant ikke gaven": "Fann ikkje gåva",
  "Gaven din": "Gåva di",
  "Pengegave {amount}": "Pengegåve {amount}",
  "Fullfør betalingen i Vipps-appen – siden oppdateres automatisk. Gaven blir lagt inn som premie når betalingen er godkjent.": "Fullfør betalinga i Vipps-appen – sida blir oppdatert automatisk. Gåva blir lagd inn som premie når betalinga er godkjend.",
  "Betalingen må fullføres innen kl. {time}": "Betalinga må fullførast innan kl. {time}",
  "Tusen takk for gaven!": "Tusen takk for gåva!",
  "Betalt {date} med Vipps": "Betalt {date} med Vipps",
  "Registrert {date}": "Registrert {date}",
  "Gaven er nå premien «{name}»": "Gåva er no premien «{name}»",
  "«{name}» er nå med i premielisten": "«{name}» er no med i premielista",
  "Beløpet gikk direkte til {org}. Vinneren trekkes sammen med de andre premiene.": "Beløpet gjekk direkte til {org}. Vinnaren blir trekt saman med dei andre premiane.",
  "Arrangøren tar kontakt for å avtale henting. Du kan også kontakte arrangøren selv: {contact}": "Arrangøren tek kontakt for å avtale henting. Du kan òg kontakte arrangøren sjølv: {contact}",
  "Arrangøren tar kontakt for å avtale henting.": "Arrangøren tek kontakt for å avtale henting.",
  "Navnet ditt vises ikke offentlig – bare arrangøren ser hvem som har gitt.": "Namnet ditt blir ikkje vist offentleg – berre arrangøren ser kven som har gitt.",
  "Betalingen er avbrutt": "Betalinga er avbroten",
  "Ingenting er trukket. Du kan prøve igjen fra basarsiden.": "Ingenting er trekt. Du kan prøve igjen frå basarsida.",
  "Bekreftelse er sendt på e-post.": "Stadfesting er send på e-post.",
  "Basaren arrangeres av {org}. Right in formidler bare gaven – pengegaver går direkte til arrangøren.": "Basaren blir arrangert av {org}. Right in formidlar berre gåva – pengegåver går direkte til arrangøren.",
  "Registrert": "Registrert",
  // Oppsett
  "Trekning og plakat": "Trekning og plakat",
  "Vises på basarsiden og på premieplakaten (A4/A3) du kan skrive ut under Gaver.": "Blir vist på basarsida og på premieplakaten (A4/A3) du kan skrive ut under Gåver.",
  "Dato og klokkeslett for trekningen": "Dato og klokkeslett for trekninga",
  "Sted for trekningen": "Stad for trekninga",
  "F.eks. Sæbøvik samfunnshus": "T.d. Sæbøvik samfunnshus",
  "Ren elektronisk trekning (uten arrangement)": "Rein elektronisk trekning (utan arrangement)",
  "Stedet vises ikke på plakaten eller basarsiden. Vinnerne publiseres på basarsiden.": "Staden blir ikkje vist på plakaten eller basarsida. Vinnarane blir publiserte på basarsida.",
  "Slå på hvis trekningen bare skjer digitalt – da skjules stedet på plakaten.": "Slå på om trekninga berre skjer digitalt – då blir staden skjult på plakaten.",
  "Merknad på plakaten (valgfritt)": "Merknad på plakaten (valfritt)",
  "F.eks. Kaffe og kaker serveres": "T.d. Kaffi og kaker vert servert",
  "Vises bare når feltet er fylt ut.": "Blir berre vist når feltet er fylt ut.",
  "Publikum kan gi pengegaver (Vipps) og gjenstander som premier fra basarsiden. Gavene legges automatisk inn i premielisten og gaveregisteret.": "Publikum kan gi pengegåver (Vipps) og gjenstandar som premiar frå basarsida. Gåvene blir automatisk lagde inn i premielista og gåveregisteret.",
  "Minste pengegave (kr)": "Minste pengegåve (kr)",
  "Standard 100 kr. Beløpet blir en egen pengepremie.": "Standard 100 kr. Beløpet blir ein eigen pengepremie.",
  "Annen informasjon om trekningen (valgfritt)": "Anna informasjon om trekninga (valfritt)",
  "F.eks. Trekning etter 17. mai-toget, vinnerne publiseres her": "T.d. Trekning etter 17. mai-toget, vinnarane blir publiserte her",
  // Dashbord: gåveregister
  "Gaver": "Gåver",
  "Gaver og gaveregister": "Gåver og gåveregister",
  "Registrer gave": "Registrer gåve",
  "Rediger gave": "Rediger gåve",
  "Gaveregister (PDF)": "Gåveregister (PDF)",
  "Plakat A4": "Plakat A4",
  "Plakat A3": "Plakat A3",
  "CSV": "CSV",
  "Skriv ut": "Skriv ut",
  "Gaveregisteret er den interne listen med givere (til innhenting). Plakaten viser premiene, trekningstidspunkt og QR-kode – aldri giverne.": "Gåveregisteret er den interne lista med givarar (til innhenting). Plakaten viser premiane, trekningstidspunkt og QR-kode – aldri givarane.",
  "Alle": "Alle",
  "Å hente": "Å hente",
  "Kansellerte": "Kansellerte",
  "Søk gave, giver, mobil …": "Søk gåve, givar, mobil …",
  "{n} gevinster · verdi {amount}": "{n} gevinstar · verdi {amount}",
  "Tinggaver å hente": "Tinggåver å hente",
  "{n} mottatt": "{n} mottekne",
  "{n} pengegave": "{n} pengegåve",
  "{n} pengegaver": "{n} pengegåver",
  "Fra publikum": "Frå publikum",
  "via «Gi premie» på basarsiden": "via «Gi premie» på basarsida",
  "Trekningen er publisert. Nye gaver kan ikke registreres, men du kan fortsatt merke gaver som mottatt.": "Trekninga er publisert. Nye gåver kan ikkje registrerast, men du kan framleis merke gåver som mottekne.",
  "Ingen gaver ennå": "Ingen gåver enno",
  "Ingen gaver passet filteret": "Ingen gåver passa filteret",
  "Gaver fra «Gi premie» på basarsiden havner her automatisk. Gaver dere får utenom nettsiden registrerer du manuelt – de blir premier med en gang.": "Gåver frå «Gi premie» på basarsida hamnar her automatisk. Gåver de får utanom nettsida registrerer du manuelt – dei blir premiar med ein gong.",
  "Prøv et annet filter eller søk.": "Prøv eit anna filter eller søk.",
  "Mottatt": "Motteke",
  "Gave": "Gåve",
  "Giver": "Givar",
  "Handling": "Handling",
  "{amount} per stk": "{amount} per stk",
  "mottatt {date}": "motteke {date}",
  "Ikke i premielisten (premien ble fjernet)": "Ikkje i premielista (premien vart fjerna)",
  "Premie: {name}": "Premie: {name}",
  "Ukjent giver": "Ukjend givar",
  "Avbryt betaling": "Avbryt betaling",
  "Slett gave": "Slett gåve",
  "Merket som mottatt": "Merkt som motteke",
  "Merking fjernet": "Merking fjerna",
  "Gaven er slettet": "Gåva er sletta",
  "Kunne ikke laste gaveregisteret": "Kunne ikkje laste gåveregisteret",
  "Giverne vises aldri offentlig – verken på basarsiden eller plakaten. Pengegaver via Vipps går direkte til deres konto og kan ikke slettes her; tilbakebetaling gjøres i Vipps-portalen.": "Givarane blir aldri viste offentleg – verken på basarsida eller plakaten. Pengegåver via Vipps går direkte til kontoen dykkar og kan ikkje slettast her; tilbakebetaling skjer i Vipps-portalen.",
  "Avbryte betalingen?": "Avbryte betalinga?",
  "Slette gaven?": "Slette gåva?",
  "Vipps-betalingen avbrytes og gaven merkes som kansellert.": "Vipps-betalinga blir avbroten og gåva merkt som kansellert.",
  "Gaven fjernes fra gaveregisteret, og premien den ga fjernes fra premielisten. Dette kan ikke angres.": "Gåva blir fjerna frå gåveregisteret, og premien ho gav blir fjerna frå premielista. Dette kan ikkje angrast.",
  "Ja, fjern": "Ja, fjern",
  // Gåveskjema (manuelt / rediger)
  "Endringer i navn, verdi og antall oppdaterer også premien (før trekningen er publisert).": "Endringar i namn, verdi og tal oppdaterer òg premien (før trekninga er publisert).",
  "Gaver dere har fått utenom nettsiden – gjenstander eller penger. Gaven legges inn som premie med en gang.": "Gåver de har fått utanom nettsida – gjenstandar eller pengar. Gåva blir lagd inn som premie med ein gong.",
  "Beløp (kr)": "Beløp (kr)",
  "Premie: «Pengepremie {amount}»": "Premie: «Pengepremie {amount}»",
  "Blir premien «Pengepremie …»": "Blir premien «Pengepremie …»",
  "Mottatt som": "Motteke som",
  "Bankoverføring": "Bankoverføring",
  "Verdi per stk (kr)": "Verdi per stk (kr)",
  "Flere like gaver = like mange separate gevinster (f.eks. 3 rosebuketter → 3 vinnere).": "Fleire like gåver = like mange separate gevinstar (t.d. 3 rosebukettar → 3 vinnarar).",
  "Giver (vises aldri offentlig)": "Givar (blir aldri vist offentleg)",
  "Navn (valgfritt)": "Namn (valfritt)",
  "Tomt = ukjent/anonym giver": "Tomt = ukjend/anonym givar",
  "Intern merknad (valgfritt)": "Intern merknad (valfritt)",
  "F.eks. hentes fredag etter kl. 15": "T.d. hentast fredag etter kl. 15",
  "Gaven er allerede mottatt": "Gåva er alt motteken",
  "Send takk til giveren på e-post": "Send takk til givaren på e-post",
  "Gaven må ha navn og verdi": "Gåva må ha namn og verdi",
  "Gaven er oppdatert": "Gåva er oppdatert",
  "Gaven er registrert": "Gåva er registrert",
};
